import React from 'react';

const ProfileWrippleProjectRow = ({project, ...props}) => {

    return (
        <div className="py-6 gap-6 flex">
            <div className="w-24 shrink-0">
                <img className="w-full" src={project.client.logo_path}/>
            </div>

            <div className="w-full">
                <p className="text-lg font-bold">{project.project.name}</p>
                <p>Company: {project.client.name}</p>
                {project.position && (
                    <p>Position: {project.position.title}</p>
                )}

                {TB.moment(project.started_at).isValid() && (
                    <p className="text-wrippleBlueGray">
                        {TB.moment(project.started_at).format('ll')}{TB.moment(project.ended_at).isValid() ? ` - ${TB.moment(project.ended_at).format('ll')}` : ''}
                    </p>
                )}
            </div>
        </div>
    )
};

export default ProfileWrippleProjectRow;